export enum TimeUnit {
  Days = "Days",
  Months = "Months",
  Weeks = "Weeks",
  Years = "Years",
}
